export default __webpack_public_path__ + "static/media/logo.9fbe0c8e.png";